// Collection 
export enum DateFormat {
    Warehouse = 'YYYYMMDDHHmm',
    HumanDisplay = 'DD/MM/YYYY @ HH:mm',
}